<script setup lang="ts">
const route = useRoute();
const { data } = await useKirbyData(route.path, {
  transform: (page: Record<string, any>) => slimPagePayload(page),
});
requirePageData(data.value);

// Set the current page data for the global page context
setPage(data.value);

useHead({
  bodyAttrs: {
    class: `comp-page`,
  },
});
definePageMeta({
  layout: "default",
});
</script>

<template>
  <div>
    <AppHeading1 />
    <AppHeroImage />
    <div class="content-wrapper">
      <div class="content">
        <KirbyLayouts v-if="data?.layouts" :layouts="data?.layouts ?? []" />
        <div v-if="data?.addForm">
          <AppFormCompForm />
        </div>
      </div>
    </div>
  </div>
</template>
